import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { devToolsEnhancer } from 'redux-devtools-extension';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import tasks from './reducers';

const store = createStore(tasks, devToolsEnhancer()); ReactDOM.render(
    <Provider store={store}> <App />
    </Provider>, document.getElementById('root')
);

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
